var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBinocularsHands = function SvgBinocularsHands(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 363,
    height: 363,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9EDFF",
    d: "M38.127 181.251a143.748 143.748 0 1 0 287.496 0 143.748 143.748 0 0 0-287.496 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M297.476 263.929c-4.162-13.703-11.608-23.787-25.415-28.157-8.165-2.58-8.186-2.516-36.253-10.896a8.03 8.03 0 0 1 4.596-15.388l12.578 3.759a30.55 30.55 0 0 0 35.413-18.206l39.936 52.224z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M297.476 263.929c-4.162-13.703-11.608-23.787-25.415-28.157-8.165-2.58-8.186-2.516-36.253-10.896a8.03 8.03 0 0 1 4.596-15.388l12.578 3.759a30.55 30.55 0 0 0 35.413-18.206l39.936 52.224z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4,
    d: "M301.889 175.283a8.03 8.03 0 0 1-14.644 1.718c-10.063-17.361-34.14-23.15-34.388-23.201a8.033 8.033 0 0 1-2.518-14.575 8.03 8.03 0 0 1 6.007-1.104c1.261.284 31.104 7.162 44.799 30.841a8 8 0 0 1 .744 6.321Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0D9FF",
    d: "m345.506 241.04-3.817-7.072a4 4 0 0 0-2.381-1.941 4.001 4.001 0 0 0-3.056.316l-40.634 21.922a4.01 4.01 0 0 0-1.624 5.441l3.812 7.068"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m345.506 241.04-3.817-7.072a4 4 0 0 0-2.381-1.941 4.001 4.001 0 0 0-3.056.316l-40.634 21.922a4.01 4.01 0 0 0-1.624 5.441l3.812 7.068"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m336.252 232.322-40.634 21.965a53.8 53.8 0 0 0-5.498-12.607 60.4 60.4 0 0 1-8.313-23.449 59.76 59.76 0 0 1 3.774-30.474l.963-2.372c5.822-15.295-4.014-31.315-26.5-43.725a94 94 0 0 0-6.947-3.572 8.034 8.034 0 0 1-3.852-10.68 8.14 8.14 0 0 1 10.68-3.853c54.402 23.086 43.804 57.334 76.327 108.767"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m336.252 232.322-40.634 21.965a53.8 53.8 0 0 0-5.498-12.607 60.4 60.4 0 0 1-8.313-23.449 59.76 59.76 0 0 1 3.774-30.474l.963-2.372c5.822-15.295-4.014-31.315-26.5-43.725a94 94 0 0 0-6.947-3.572 8.034 8.034 0 0 1-3.852-10.68 8.14 8.14 0 0 1 10.68-3.853c54.402 23.086 43.804 57.334 76.327 108.767"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65.524 263.929c4.162-13.703 11.608-23.787 25.415-28.157 8.165-2.58 8.186-2.516 36.253-10.896a8.03 8.03 0 0 0-4.596-15.388l-12.578 3.759a30.55 30.55 0 0 1-35.413-18.206L34.67 247.265z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M65.524 263.929c4.162-13.703 11.608-23.787 25.415-28.157 8.165-2.58 8.186-2.516 36.253-10.896a8.03 8.03 0 0 0-4.596-15.388l-12.578 3.759a30.55 30.55 0 0 1-35.413-18.206L34.67 247.265z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4,
    d: "M61.111 175.283a8.03 8.03 0 0 0 11.293 4.878 8.03 8.03 0 0 0 3.351-3.16c10.045-17.361 34.14-23.15 34.388-23.201a8.033 8.033 0 0 0 2.518-14.575 8.03 8.03 0 0 0-6.007-1.104c-1.261.284-31.103 7.162-44.8 30.841a8 8 0 0 0-.743 6.321Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0D9FF",
    d: "m17.494 241.04 3.817-7.072a4 4 0 0 1 2.381-1.941 4.004 4.004 0 0 1 3.056.316l40.634 21.922a4 4 0 0 1 1.94 2.384 4 4 0 0 1-.316 3.057l-3.813 7.068"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m17.494 241.04 3.817-7.072a4 4 0 0 1 2.381-1.941 4.004 4.004 0 0 1 3.056.316l40.634 21.922a4 4 0 0 1 1.94 2.384 4 4 0 0 1-.316 3.057l-3.813 7.068"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.748 232.322 40.634 21.965a53.8 53.8 0 0 1 5.498-12.607 60.4 60.4 0 0 0 8.313-23.449 59.76 59.76 0 0 0-3.774-30.474l-.963-2.372c-5.822-15.295 4.014-31.315 26.5-43.725a94 94 0 0 1 6.947-3.572 8.034 8.034 0 0 0 3.852-10.68 8.14 8.14 0 0 0-10.68-3.853c-54.402 23.086-43.804 57.334-76.327 108.767"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m26.748 232.322 40.634 21.965a53.8 53.8 0 0 1 5.498-12.607 60.4 60.4 0 0 0 8.313-23.449 59.76 59.76 0 0 0-3.774-30.474l-.963-2.372c-5.822-15.295 4.014-31.315 26.5-43.725a94 94 0 0 1 6.947-3.572 8.034 8.034 0 0 0 3.852-10.68 8.14 8.14 0 0 0-10.68-3.853c-54.402 23.086-43.804 57.334-76.327 108.767"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4,
    d: "m162.399 163.672-17.034-17.034 25.552-19.877 11.356 11.356z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4,
    d: "M124.626 132.949a16.06 16.06 0 0 1 18.91 2.096l24.754 22.798a16.07 16.07 0 0 1 5.081 13.581 16.07 16.07 0 0 1-7.931 12.139l-36.717 21.203a16.06 16.06 0 0 1-21.922-5.879l-16.078-27.808a16.06 16.06 0 0 1 5.88-21.94z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M124.626 132.949a16.06 16.06 0 0 1 18.91 2.096l24.754 22.798a16.07 16.07 0 0 1 5.081 13.581 16.07 16.07 0 0 1-7.931 12.139l-36.717 21.203a16.06 16.06 0 0 1-21.922-5.879l-16.078-27.808a16.06 16.06 0 0 1 5.88-21.94z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#020064",
    strokeWidth: 4,
    d: "M124.626 132.949a16.06 16.06 0 0 1 18.91 2.096l24.754 22.798a16.07 16.07 0 0 1 5.081 13.581 16.07 16.07 0 0 1-7.931 12.139l-36.717 21.203a16.06 16.06 0 0 1-21.922-5.879l-16.078-27.808a16.06 16.06 0 0 1 5.88-21.94z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4,
    d: "M67.957 178.96a40.147 40.147 0 0 0 77.235 15.363 40.155 40.155 0 0 0-8.703-43.75 40.144 40.144 0 0 0-68.532 28.387Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M79.996 178.959a28.107 28.107 0 1 0 56.213 0 28.107 28.107 0 0 0-56.213 0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#020064",
    strokeWidth: 4,
    d: "M79.996 178.959a28.107 28.107 0 1 0 56.213 0 28.107 28.107 0 0 0-56.213 0Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4,
    d: "m200.6 163.672 17.035-17.034-25.552-19.877-11.356 11.356z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M165.44 130.779a16.06 16.06 0 1 0 32.12 0 16.06 16.06 0 0 0-32.12 0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4,
    d: "M238.374 132.949a16.06 16.06 0 0 0-18.91 2.096l-24.754 22.798a16.06 16.06 0 0 0 2.85 25.72l36.717 21.203a16.06 16.06 0 0 0 21.922-5.879l16.078-27.808a16.07 16.07 0 0 0-1.168-17.808 16 16 0 0 0-4.712-4.132z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M238.374 132.949a16.06 16.06 0 0 0-18.91 2.096l-24.754 22.798a16.06 16.06 0 0 0 2.85 25.72l36.717 21.203a16.06 16.06 0 0 0 21.922-5.879l16.078-27.808a16.07 16.07 0 0 0-1.168-17.808 16 16 0 0 0-4.712-4.132z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#020064",
    strokeWidth: 4,
    d: "M238.374 132.949a16.06 16.06 0 0 0-18.91 2.096l-24.754 22.798a16.06 16.06 0 0 0 2.85 25.72l36.717 21.203a16.06 16.06 0 0 0 21.922-5.879l16.078-27.808a16.07 16.07 0 0 0-1.168-17.808 16 16 0 0 0-4.712-4.132zM165.44 130.779a16.06 16.06 0 1 0 32.12 0 16.06 16.06 0 0 0-32.12 0Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeWidth: 4,
    d: "M214.752 178.96a40.146 40.146 0 1 0 80.291-.002 40.146 40.146 0 0 0-80.291.002Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M226.792 178.959a28.106 28.106 0 1 0 56.212 0 28.106 28.106 0 0 0-56.212 0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    stroke: "#020064",
    strokeWidth: 4,
    d: "M226.792 178.959a28.106 28.106 0 1 0 56.212 0 28.106 28.106 0 0 0-56.212 0Z"
  })));
};
export default SvgBinocularsHands;